console.log("✅ โหลดไฟล์ custom.js สำเร็จแล้ว!");

// 1. ฟังก์ชันสำหรับสลับหน้าต่าง Tab (บังคับให้อยู่ใน window)
window.openTab = function(evt, tabName) {
    var tabcontent = document.getElementsByClassName("jtb-tab-content");
    for (var i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
        tabcontent[i].classList.remove("active");
    }

    var tablinks = document.getElementsByClassName("jtb-tab-button");
    for (var i = 0; i < tablinks.length; i++) {
        tablinks[i].classList.remove("active");
    }

    document.getElementById(tabName).style.display = "block";
    document.getElementById(tabName).classList.add("active");
    evt.currentTarget.classList.add("active");
};

// 2. ฟังก์ชันสำหรับกดลูกศรเลื่อนรูป ซ้าย-ขวา
window.changeSlide = function(element, step) {
    let carousel = element.closest('.jtb-carousel');
    let images = carousel.querySelectorAll('img');
    let dots = carousel.querySelectorAll('.jtb-dot');
    
    let currentIndex = Array.from(images).findIndex(img => img.classList.contains('active'));
    if (currentIndex === -1) currentIndex = 0;
    
    let newIndex = currentIndex + step;
    
    if (newIndex >= images.length) newIndex = 0;
    if (newIndex < 0) newIndex = images.length - 1;
    
    window.updateCarouselDisplay(images, dots, newIndex);
};

// 3. ฟังก์ชันสำหรับกดที่จุดไข่ปลาโดยตรง
window.setSlide = function(element, index) {
    let carousel = element.closest('.jtb-carousel');
    let images = carousel.querySelectorAll('img');
    let dots = carousel.querySelectorAll('.jtb-dot');
    
    window.updateCarouselDisplay(images, dots, index);
};

// 4. ฟังก์ชันอัปเดตการแสดงผลของรูปและจุด
window.updateCarouselDisplay = function(images, dots, newIndex) {
    images.forEach(img => img.classList.remove('active'));
    dots.forEach(dot => dot.classList.remove('active'));
    
    if(images[newIndex]) images[newIndex].classList.add('active');
    if(dots[newIndex]) dots[newIndex].classList.add('active');
};

///////////////////////////////////////////////////////////////////////////////////
// Shizuoka Page Script //

document.addEventListener('DOMContentLoaded', function() {
  
  // 1. ระบบ Accordion (เปิด-ปิดเนื้อหา)
  const accordions = document.querySelectorAll(".model-course-accordion");
  
  accordions.forEach(function(acc) {
    acc.addEventListener("click", function() {
      // สลับคลาส active 
      this.classList.toggle("active");
      
      // เลือก div.model-course-panel ที่อยู่ติดกัน
      let panel = this.nextElementSibling;
      
      if (panel.style.maxHeight) {
        // ถ้าเปิดอยู่ ให้ปิด
        panel.style.maxHeight = null;
        panel.style.borderBottom = "none";
      } else {
        // ถ้าปิดอยู่ ให้เปิด
        panel.style.maxHeight = panel.scrollHeight + "px";
        panel.style.borderBottom = "1px solid #ddd";
      } 
    });
  });

  // เปิด Accordion อันแรกค้างไว้ตอนโหลดหน้าเว็บ
  const firstPanel = accordions[0].nextElementSibling;
  firstPanel.style.maxHeight = firstPanel.scrollHeight + "px";
  firstPanel.style.borderBottom = "1px solid #ddd";

});

// 2. ฟังก์ชันปิดแถบจากปุ่มด้านล่าง
function closeThisAccordion(buttonElement) {
    const panel = buttonElement.closest('.model-course-panel');
    
    if (panel) {
        // 1. สั่งให้หดกล่องเนื้อหากลับไป (เริ่มเล่น Animation)
        panel.style.maxHeight = null;
        panel.style.borderBottom = "none";
        
        // เอาคลาส active ออกจากปุ่มหัวข้อ
        const header = panel.previousElementSibling;
        if (header && header.classList.contains('model-course-accordion')) {
            header.classList.remove('active');
        }
            
        // 2. หน่วงเวลา 400 มิลลิวินาที (ให้เท่ากับเวลา 0.4s ใน CSS) 
        // เพื่อรอให้กล่องปิดสนิทก่อน แล้วค่อยคำนวณตำแหน่งและเลื่อนหน้าจอ
        setTimeout(() => {
            const allAccordions = document.querySelectorAll('.model-course-accordion');
            if (allAccordions.length > 0) {
                const firstAccordion = allAccordions[0]; 
                const headerOffset = 100; // ระยะเว้นขอบด้านบน
                
                // คำนวณพิกัดใหม่หลังจากที่หน้าเว็บจัดระเบียบความสูงเสร็จแล้ว
                const elementPosition = firstAccordion.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                // สั่งเลื่อนหน้าจอแบบสมูท
                window.scrollTo({ top: offsetPosition, behavior: "smooth" });
            }
        }, 400); 
    }
}

// 3. ฟังก์ชันสำหรับควบคุม Popup Modal สถานที่ท่องเที่ยว
const modal = document.getElementById("infoModal");
const modalTitle = document.getElementById("modal-title");
const modalDesc = document.getElementById("modal-desc");
const modalImage1 = document.getElementById("modal-image-1"); // รูปที่ 1
const modalImage2 = document.getElementById("modal-image-2"); // รูปที่ 2

// ฟังก์ชันเปิด Modal รับค่า: ชื่อ, รายละเอียด, ลิงก์รูป 1, ลิงก์รูป 2
function openModal(title, description, imageUrl1, imageUrl2) {
  modalTitle.innerText = title;
  modalDesc.innerHTML = description;
  
  // ตรวจสอบและจัดการ "รูปภาพที่ 1"
  if (imageUrl1) {
    modalImage1.src = imageUrl1;
    modalImage1.style.display = "block";
    // ถ้ารูปที่ 2 ไม่มี ให้รูปแรกกว้าง 100% เต็มกล่อง แต่ถ้ามีรูปที่ 2 ให้กว้าง 50%
    modalImage1.style.width = imageUrl2 ? "50%" : "100%"; 
  } else {
    modalImage1.src = ""; 
    modalImage1.style.display = "none";
  }

  // ตรวจสอบและจัดการ "รูปภาพที่ 2"
  if (imageUrl2) {
    modalImage2.src = imageUrl2;
    modalImage2.style.display = "block";
  } else {
    modalImage2.src = ""; 
    modalImage2.style.display = "none";
  }
  
  modal.style.display = "flex"; 
}

// ฟังก์ชันปิด Modal
function closeModal() {
  modal.style.display = "none";
}

// ปิด Modal เมื่อคลิกพื้นที่ว่างสีเทาด้านนอก
window.onclick = function(event) {
  if (event.target == modal) {
    closeModal();
  }
}
///////////////////////////////////////////////////////////////////////////////////










